import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { R as N, T as $, C as v } from "../../../index-9uMnZef2.js";
import { c as n } from "../../../clsx-OuTLNxxd.js";
import { useState as y } from "react";
import { I as j } from "../../../icon-B72I4fRl.js";
import "../icon/iconsList.js";
const I = "_collapsible_7sxdd_29", R = "_arrow_7sxdd_39", l = {
  collapsible: I,
  "collapsible-trigger": "_collapsible-trigger_7sxdd_29",
  "open-top": "_open-top_7sxdd_39",
  arrow: R,
  "open-bottom": "_open-bottom_7sxdd_39",
  "is-highlighted": "_is-highlighted_7sxdd_52",
  "collapsible-label": "_collapsible-label_7sxdd_56",
  "collapsible-container": "_collapsible-container_7sxdd_63",
  "is-borderless": "_is-borderless_7sxdd_63",
  "collapsible-content": "_collapsible-content_7sxdd_67",
  "is-full-width": "_is-full-width_7sxdd_86",
  "dialog-overlay-show": "_dialog-overlay-show_7sxdd_1",
  "dialog-content-show": "_dialog-content-show_7sxdd_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7sxdd_1"
}, B = ({
  className: c = "",
  labelOpen: r,
  labelClosed: _,
  children: p,
  onChange: b = () => null,
  isOpen: g = !1,
  openOn: s = "top",
  isHighlighted: h = !1,
  isBorderless: m = !1,
  isFullWidth: e = !1,
  ...x
}) => {
  const [a, f] = y(g), w = (t) => {
    f(t), b(t);
  }, i = /* @__PURE__ */ o(v, { className: l["collapsible-content"], children: p }), u = n(l["collapsible-trigger"], l[`open-${s}`]), C = n(
    l["collapsible-container"],
    l[`open-${s}`],
    h && l["is-highlighted"],
    m && l["is-borderless"],
    e && l["is-full-width"]
  );
  return /* @__PURE__ */ o(
    N,
    {
      className: `${l.collapsible} ${c} ${e && l["is-full-width"]}`,
      open: a,
      onOpenChange: w,
      ...x,
      children: /* @__PURE__ */ d("div", { className: C, children: [
        s === "top" && i,
        /* @__PURE__ */ d($, { className: u, children: [
          /* @__PURE__ */ o(j, { name: "up-arrow", className: l.arrow, size: "small" }),
          /* @__PURE__ */ o("span", { className: l["collapsible-label"], children: a ? _ : r })
        ] }),
        s === "bottom" && i
      ] })
    }
  );
};
export {
  B as Collapsible
};
